export default function bannerSlider() {
  // Banner slide
  const bannerSlide = document.querySelectorAll('.banner-slide .wp-block-image');
  const bannerLoad = document.querySelector('.banner-slide__loader .loading-bar');
  let bannerSlideIndex = 0;
  bannerSlide[0].classList.add('active');
  bannerLoad.classList.add('start');
  let bannerSlideTimer = setInterval(() => {
    bannerSlide.forEach(slide => {
      slide.classList.remove('active');
    });
    bannerSlideIndex++;
    if (bannerSlideIndex >= bannerSlide.length) bannerSlideIndex = 0;
    bannerSlide[bannerSlideIndex].classList.add('active');
  }, 5000);
}